import http from "../services/http";
import { __api_userResetPassword } from "./endpoints";

export const resetPassword = (token, data) => http.Request("POST", __api_userResetPassword + "/" + token, data);